import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { Divider, H, P, Wrapper } from '@farewill/ui'
import { BORDER, COLOR, GTR, FONT } from '@farewill/ui/tokens'

import Specialists from 'components/Specialists'
import TelephoneNumber from 'components/TelephoneNumber'
import { PROBATE } from 'lib/products/constants'
import { PROBATE_TELEPHONE_NUMBER } from 'config'

import NotesList from './NotesList'

const StyledWrapper = styled(Wrapper)`
  box-shadow: ${BORDER.SHADOW.M};
`

const ContactSectionWrapper = styled(Wrapper)`
  display: flex;
  flex-direction: column;
  align-items: start;

  ${'' /* for IE11: text breaks out of container otherwise */}
  p {
    width: 100%;
  }
`

const StyledTelephoneNumber = styled(TelephoneNumber)`
  margin-bottom: ${GTR.M};

  @media only screen and (max-width: 400px) {
    font-size: ${FONT.SIZE.L};
  }
`

const Result = ({ estimates, notes }) => (
  <StyledWrapper
    container
    paddingFromM={['L']}
    background={COLOR.WHITE}
    borderRadius="S"
    aria-live="polite"
  >
    <Wrapper
      centered
      background={COLOR.ACCENT.SECONDARY}
      padding={['M']}
      margin={[0, 0, 'M']}
      borderRadius="S"
    >
      <H size="S" color={COLOR.WHITE} margin={0}>
        {`${estimates.probateMin} to ${estimates.probateMax} months`}
      </H>
      <P color={COLOR.WHITE} size="S">
        to get probate
      </P>
    </Wrapper>

    {!!notes.probate.length && <NotesList notes={notes.probate} />}

    <Wrapper
      centered
      bordered
      background={COLOR.BACKGROUND.FOG}
      padding={['M']}
      margin={[0, 0, 'M']}
      borderRadius="S"
    >
      <H size="S" margin={0}>
        {`+ ${estimates.estateAdminMin} to ${estimates.estateAdminMax} months`}
      </H>
      <P size="S">for all beneficiaries to receive their share of the estate</P>
    </Wrapper>

    {!!notes.estateAdmin.length && (
      <>
        <NotesList notes={notes.estateAdmin} />

        <Divider margin={[0, 0, 'M']} />
      </>
    )}

    <ContactSectionWrapper>
      <P margin={[0, 0, 'L']} marginFromM={[0, 0, 'M', 'S']} size="S">
        This is a rough estimate only. If you’d like to find out more about our
        Essential Probate and Complete Probate services, please call our
        friendly specialists.
      </P>
      <StyledTelephoneNumber
        telephoneNumber={PROBATE_TELEPHONE_NUMBER}
        size="large"
        highlighted
        highlightColor={COLOR.ACCENT.PRIMARY}
      />
      <Specialists group={PROBATE} extraSmall outlineColor={COLOR.WHITE} />
    </ContactSectionWrapper>
  </StyledWrapper>
)

Result.propTypes = {
  estimates: PropTypes.shape({
    probateMin: PropTypes.number.isRequired,
    probateMax: PropTypes.number.isRequired,
    estateAdminMin: PropTypes.number.isRequired,
    estateAdminMax: PropTypes.number.isRequired,
  }).isRequired,
  notes: PropTypes.shape({
    probate: PropTypes.arrayOf(PropTypes.string),
    estateAdmin: PropTypes.arrayOf(PropTypes.string),
  }),
}

Result.defaultProps = {
  notes: { probate: [], estateAdmin: [] },
}

export default Result
